import React, { useState } from 'react';
import './TopList.css'

const TopAgentsList = ({ data, filters }) => {
  const getDateStr = (date) =>
    date instanceof Date ? date.toLocaleDateString('en-CA') : new Date(date).toLocaleDateString('en-CA');

  // Filter data by customer and selected date
  const filtered = data.filter((d) => {
    const matchCustomer = !filters.customer || d.Customer === filters.customer;
    const matchDate = !filters.selectedDate || getDateStr(d.Date) === filters.selectedDate;
    return matchCustomer && matchDate;
  });

  // Initialize counts for handled, missed, rejected
  const handledCounts = {};
  const missedCounts = {};
  const rejectedCounts = {};

  filtered.forEach((d) => {
    if (!handledCounts[d.Agent]) handledCounts[d.Agent] = 0;
    if (!missedCounts[d.Agent]) missedCounts[d.Agent] = 0;
    if (!rejectedCounts[d.Agent]) rejectedCounts[d.Agent] = 0;

    handledCounts[d.Agent] += d.Handled || 0;
    missedCounts[d.Agent] += d.Missed || 0;
    rejectedCounts[d.Agent] += d.Rejected || 0;
  });

  // Sort descending by count for each category
  const sortedHandled = Object.entries(handledCounts).sort((a, b) => b[1] - a[1]);
  const sortedMissed = Object.entries(missedCounts).sort((a, b) => b[1] - a[1]);
  const sortedRejected = Object.entries(rejectedCounts).sort((a, b) => b[1] - a[1]);

  // State to track load more toggles
  const [showAllHandled, setShowAllHandled] = useState(false);
  const [showAllMissed, setShowAllMissed] = useState(false);
  const [showAllRejected, setShowAllRejected] = useState(false);

  // Helper to render a list with numbering and load more
  const renderList = (title, list, showAll, setShowAll) => {
    const displayList = showAll ? list : list.slice(0, 10);

    return (
      <div style={{ marginBottom: 20 }}>
        <h4>{title}</h4>
        <ul style={{ paddingLeft: 20, listStyle: 'none', fontSize: '0.8rem' }}>
          {displayList.map(([agent, count], i) => (
            <li key={`${title}-${agent}`}>
              <p style={{ padding: 0, margin: 0 }}><strong style={{ marginRight: '1rem' }}>{i + 1}.</strong> {agent}: <strong>{count}</strong></p>
            </li>
          ))}
        </ul>
        {list.length > 10 && (
          <button
            onClick={() => setShowAll(!showAll)}
            className='toplist-loadmore'
          >
            {showAll ? 'Show Less' : 'Load More'}
          </button>
        )}
      </div>
    );
  };

  return (
    <div style={{ marginTop: 20 }}>
      {renderList('Handled Calls', sortedHandled, showAllHandled, setShowAllHandled)}
      {renderList('Missed Calls', sortedMissed, showAllMissed, setShowAllMissed)}
      {renderList('Rejected Calls', sortedRejected, showAllRejected, setShowAllRejected)}
    </div>
  );
};

export default TopAgentsList;
